const memoryCache = new Map()
const failedCache = new Set()

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

function getBaseUrl(url) {
  return url.split('?')[0]
}

export async function getCachedImageUrl(url) {
  if (!url) return url

  const baseUrl = getBaseUrl(url)

  if (memoryCache.has(baseUrl)) return memoryCache.get(baseUrl)
  if (failedCache.has(baseUrl)) return url

  const storageKey = 'img_cache_' + baseUrl
  try {
    const cached = localStorage.getItem(storageKey)
    if (cached) {
      memoryCache.set(baseUrl, cached)
      return cached
    }
  } catch {}

  try {
    const response = await fetch(url, { credentials: 'same-origin' })
    if (!response.ok) {
      failedCache.add(baseUrl)
      return url
    }
    const blob = await response.blob()
    const dataUrl = await blobToDataUrl(blob)
    memoryCache.set(baseUrl, dataUrl)
    try {
      localStorage.setItem(storageKey, dataUrl)
    } catch {}
    return dataUrl
  } catch {
    failedCache.add(baseUrl)
    return url
  }
}
